import { useState, useEffect } from 'react';
import { reduce } from 'underscore';

import { setClarityTag } from '@bingads-webui-universal/clarity';

export const useClarityTags = (customTags) => {
  const [haveSetClarityTags, setHaveSetClarityTags] = useState(false);

  useEffect(() => {
    if (!haveSetClarityTags) {
      const tagsToSet = reduce(customTags, (tagsObj, currentTag) => ({
        ...tagsObj,
        [currentTag]: true,
      }), {});

      setClarityTag(tagsToSet);
      setHaveSetClarityTags(true);
    }
  }, [haveSetClarityTags, setHaveSetClarityTags, customTags]);
};
